import { pawnshop_reports_reader_service_v4 } from "../../../api/restclient";

import moment from "moment";

export const makeRequest = async (endpoint, params, method = "get") => {
  const response =
    method === "get"
      ? await pawnshop_reports_reader_service_v4.get(endpoint, params)
      : await pawnshop_reports_reader_service_v4.post(endpoint, params);
  return response;
};

export const constructUrlParamsByRange = (from, to) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", from);
  urlParams.append("to", to);
  return urlParams;
};

export const constructUrlParamsBySpecificDate = (coveredDate) => {
  const urlParams = new URLSearchParams();
  urlParams.append("coveredDate", coveredDate);
  return urlParams;
};
export const constructUrlByMonthYearParams = (data) => {
  const arrayParams = new URLSearchParams();
  arrayParams.append("fromMonth", data.fromMonth);
  arrayParams.append("fromYear", data.fromYear);
  arrayParams.append("toMonth", data.toMonth);
  arrayParams.append("toYear", data.toYear);
  return arrayParams;
};

export const formatDateParam = (date) => moment(date).format("YYYY-MM-DD");
